module.exports = __webpack_public_path__ + "img/case_bottom_009.308ed983.png";